import React from "react";

import "./Hero.scss";

export default function Hero() {
  return (
    <div className="hero">
      <div className="slider">
        <div className="slide1"></div>
        <div className="slide2"></div>
        <div className="slide3"></div>
        <div className="slide4"></div>
        <div className="slide5"></div>
      </div>
    </div>
  );
}
